import { __assign, __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { HeaderBalance } from '../HeaderBalance';
import { HeaderBrand } from '../HeaderBrand';
import { HeaderContent } from '../HeaderContent';
export var Header = function (props) {
    var componentClass = 'header';
    var _a = props.isHomeHeader, isHomeHeader = _a === void 0 ? false : _a, className = props.className, children = props.children, otherProps = __rest(props, ["isHomeHeader", "className", "children"]);
    var _b = useState(isHomeHeader), applyHomeClass = _b[0], setApplyHomeClass = _b[1];
    var listenScrollEvent = function () { return setApplyHomeClass(window.scrollY < 20); };
    var classes = cx(className, componentClass, { 'header--transparent': applyHomeClass });
    useEffect(function () {
        if (isHomeHeader) {
            window.addEventListener('scroll', listenScrollEvent);
        }
        setApplyHomeClass(isHomeHeader);
        return function () { return window.removeEventListener('scroll', listenScrollEvent); };
    }, [isHomeHeader]);
    return (React.createElement("header", __assign({}, otherProps, { className: classes }),
        React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "d-flex align-items-center justify-content-between flex-lg-nowrap" }, children))));
};
Header.Balance = HeaderBalance;
Header.Brand = HeaderBrand;
Header.Content = HeaderContent;
//# sourceMappingURL=Header.js.map